import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../common/index';
import { AppSettings } from '../../../settings/index';

@Injectable()
export class TicketStatusService {
    constructor(private http: AuthHttp) { }

    get() {
        return this.http.get(AppSettings.apiEndpoint + 'TicketStatus/Get')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/op/ticket-status.service.ts